import { observer } from 'mobx-react-lite';
import { TabMode } from '../../../../event-panel/tabs/components/types';
import { TabsWrapper } from '../../../../event-panel/tabs/components/tabs-wrapper';
import { useActiveBoloPanelTab } from '../../state/active-bolo-panel-tab-provider';
import { TabList, Tabs } from '@cad-arc';
import { boloPanelTabConfig } from '../../config/bolo-panel-tabs-config';
import { BoloPanelTabHeader } from './bolo-panel-tab-header';
import { ActiveBoloTab } from './active-bolo-tab';
import { useBoloPanelMetadata } from '../../state/bolo-panel-metadata-context';
import { useEnabledFeatures } from '../../../../common/hooks/enabled-features/use-enabled-features';

export const BoloPanelTabs = observer(function BoloPanelTabs({ mode }: { mode: TabMode }) {
    const activeTab = useActiveBoloPanelTab();
    const isSaved = !!useBoloPanelMetadata()?.boloId;
    const enabledFeatures = useEnabledFeatures();

    return (
        <TabsWrapper mode={mode}>
            <>
                <ActiveBoloTab activeTab={activeTab} mode={mode} />
                <Tabs
                    loop={false}
                    isManual={true}
                    value={activeTab}
                    style={{
                        width: '100%',
                        backgroundColor: 'var(--arc-colors-surface-foreground)',
                        zIndex: 5,
                    }}
                >
                    <TabList
                        style={{
                            borderBottom: 'none',
                            borderTop: 'solid 1px var(--arc-colors-border-default)',
                            width: '100%',
                            overflowX: 'hidden',
                        }}
                    >
                        {Object.values(boloPanelTabConfig)
                            .filter((t) => (isSaved ? true : t.showOnNewPanel))
                            .filter((t) => !t.checkEnabled || t.checkEnabled(enabledFeatures))
                            .map((tabConfig) => (
                                <BoloPanelTabHeader
                                    key={tabConfig.type}
                                    value={tabConfig.type}
                                    leadingVisual={tabConfig.icon}
                                    tooltip={tabConfig.name}
                                    errorFields={tabConfig.errorFields}
                                    tabHeaderWidth="max-content"
                                />
                            ))}
                    </TabList>
                </Tabs>
            </>
        </TabsWrapper>
    );
});
